import { Column, Row, Skeleton } from 'components/Blocks';
import { GoBackButton } from 'components/Buttons';

export function LoadingProject() {
  return (
    <Column>
      <Row>
        <GoBackButton />

        <Skeleton circle width={36} height={36} />

        <Column gap="2">
          <Skeleton width={180} height={30} />
          <Skeleton width={100} height={20} />
        </Column>
      </Row>

      <Skeleton width="100%" height={36} />

      <Row>
        <Skeleton width={90} height={42} />
        <Skeleton width={140} height={42} />
        <Skeleton width={95} height={42} />
      </Row>

      <Skeleton width="100%" height={42} quantity={5} />
    </Column>
  );
}
